import ClubService from '@/services/club.service'
import { debounce } from '@/lib/debounce'

/**
 * Fills `model.shortName` from the typed `model.name` with the same API suggestion the quick club creation of the
 * schedule uses. The short name follows the name only while it is empty or still the value suggested last, so a short
 * name typed by hand (or already saved on the club) is never overwritten.
 */
export default {
  data () {
    return {
      suggestedShortName: ''
    }
  },
  watch: {
    'model.name' (val, oldVal) {
      // The model is replaced when a saved club is loaded: that is not typing
      if (oldVal === undefined) return
      this.suggestShortName(val)
    }
  },
  created () {
    this.suggestShortName = debounce(function (name) {
      const shortName = this.model.shortName || ''
      if (shortName && shortName !== this.suggestedShortName) return

      if (!name || !name.trim()) {
        this.suggestedShortName = ''
        this.$set(this.model, 'shortName', '')
        return
      }

      ClubService.suggestShortName(name).then((response) => {
        const current = this.model.shortName || ''
        if (current && current !== this.suggestedShortName) return

        this.suggestedShortName = response.data.shortName
        this.$set(this.model, 'shortName', response.data.shortName)
      })
    })
  }
}
